import { Card, CardContent, Grid, Typography } from "@mui/material";
import { YouTubeChannel } from "../youtubechannel.types";
import YouTubeChannelStatusChip from "./YoutubeStatusChip";
import CustomTextField from "../../../../components/common/Textfield";

interface Props {
  channel: YouTubeChannel;
}

export default function ChannelBasicInfoSection({ channel }: Props) {
  return (
    <Card sx={{ boxShadow: 0 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Basic Information
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <CustomTextField
              fullWidth
              label="Company"
              value={channel.company.name}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <CustomTextField
              fullWidth
              label="Internal Name"
              value={channel.name}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <CustomTextField
              fullWidth
              label="Display Name"
              value={channel.display_name || ""}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <CustomTextField
              fullWidth
              label="Needs Reauth"
              value={channel.needs_reauth ? "Yes" : "No"}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Status
            </Typography>
            <YouTubeChannelStatusChip isActive={channel.is_active} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
